import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, withCtx as _withCtx, createBlock as _createBlock, normalizeStyle as _normalizeStyle, createTextVNode as _createTextVNode } from "vue";
const _hoisted_1 = {
  key: 0,
  class: "btn-flex"
};
const _hoisted_2 = ["onClick"];
const _hoisted_3 = ["onClick"];
const _hoisted_4 = {
  key: 2,
  class: "span_checkbox"
};
const _hoisted_5 = {
  key: 3
};
const _hoisted_6 = {
  class: "upload_span"
};
const _hoisted_7 = ["src"];
const _hoisted_8 = {
  key: 0,
  class: "operation_div"
};
const _hoisted_9 = {
  key: 1,
  class: "operation_div"
};
const _hoisted_10 = {
  class: "operation_div"
};
const _hoisted_11 = {
  class: "operation_div"
};
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_vxe_checkbox = _resolveComponent("vxe-checkbox");
  const _component_el_upload = _resolveComponent("el-upload");
  const _component_vxe_column = _resolveComponent("vxe-column");
  const _component_el_icon = _resolveComponent("el-icon");
  const _component_vxe_button = _resolveComponent("vxe-button");
  const _component_vxe_input = _resolveComponent("vxe-input");
  const _component_vxe_table = _resolveComponent("vxe-table");
  return _openBlock(), _createElementBlock(_Fragment, null, [_ctx.data.tableHeader && _ctx.data.tableHeader.length > 0 ? (_openBlock(), _createElementBlock("div", _hoisted_1, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.data.tableHeader, (item, index) => {
    return _openBlock(), _createElementBlock("div", {
      class: "btn-group",
      key: index
    }, [item.style_self == 'btn' ? (_openBlock(), _createElementBlock("span", {
      key: 0,
      class: _normalizeClass(!item.color ? 'span_color_n' : ''),
      onClick: $event => _ctx.comBtnClick(item)
    }, _toDisplayString(item.name), 11, _hoisted_2)) : _createCommentVNode("", true), item.style_self == 'btn_n_drag' ? (_openBlock(), _createElementBlock("span", {
      key: 1,
      class: _normalizeClass(item.color ? 'span_color_drag' : ''),
      onClick: $event => _ctx.comBtnClick(item)
    }, _toDisplayString(item.name), 11, _hoisted_3)) : _createCommentVNode("", true), item.style_self == 'btn_checkout' ? (_openBlock(), _createElementBlock("span", _hoisted_4, [_createVNode(_component_vxe_checkbox, {
      modelValue: _ctx.data.top_btn_checkbox,
      "onUpdate:modelValue": _cache[0] || (_cache[0] = $event => _ctx.data.top_btn_checkbox = $event),
      size: "small",
      content: item.name,
      onChange: $event => _ctx.comBtnClick(item)
    }, null, 8, ["modelValue", "content", "onChange"])])) : _createCommentVNode("", true), item.style_self == 'btn_upload' ? (_openBlock(), _createElementBlock("span", _hoisted_5, [_createVNode(_component_el_upload, {
      "file-list": _ctx.data.fileListTableTop,
      "onUpdate:fileList": _cache[1] || (_cache[1] = $event => _ctx.data.fileListTableTop = $event),
      class: "upload-demo",
      action: item.upload_url,
      "show-file-list": false,
      "on-success": _ctx.handleSucessTableTop,
      multiple: "",
      "before-upload": _ctx.handleBeforeUploadTableTop,
      "with-credentials": _ctx.data.withcredentials,
      limit: 100000
    }, {
      default: _withCtx(() => [_createElementVNode("span", _hoisted_6, _toDisplayString(item.name), 1)]),
      _: 2
    }, 1032, ["file-list", "action", "on-success", "before-upload", "with-credentials"])])) : _createCommentVNode("", true)]);
  }), 128))])) : _createCommentVNode("", true), (_openBlock(), _createBlock(_component_vxe_table, {
    ref: "getDomN",
    class: "my-table",
    border: "",
    resizable: "",
    "max-height": _ctx.tableHeigth,
    "scroll-x": {
      enabled: false
    },
    "row-config": {
      isHover: true
    },
    "scroll-y": {
      enabled: false
    },
    data: _ctx.data.list,
    onCheckboxChange: _ctx.getSelectRow,
    onCheckboxAll: _ctx.getSelectRow,
    "show-footer": _ctx.data.showFooter,
    "merge-footer-items": _ctx.data.mergeFooterItems,
    loading: _ctx.data.loading,
    "keep-source": "",
    "edit-config": {
      trigger: 'click',
      mode: 'cell',
      showStatus: true
    },
    "column-config": {
      resizable: true
    },
    "sync-resize": _ctx.titleTag,
    key: _ctx.titleTag
  }, {
    default: _withCtx(() => [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.data.listHeader, (item, index) => {
      return _openBlock(), _createElementBlock("div", {
        key: _ctx.titleTag ? _ctx.titleTag : '' + item.field + index + _ctx.data.headerIndex
      }, [item.type == 'text' ? (_openBlock(), _createBlock(_component_vxe_column, {
        key: 0,
        field: item.field,
        title: item.title,
        width: item.width,
        align: item.align
      }, null, 8, ["field", "title", "width", "align"])) : _createCommentVNode("", true), item.type == 'text_color_column' ? (_openBlock(), _createBlock(_component_vxe_column, {
        key: 1,
        field: item.field,
        title: item.title,
        width: item.width,
        align: item.align
      }, {
        default: _withCtx(({
          row
        }) => [_createElementVNode("span", {
          style: _normalizeStyle({
            'color': item.color_s
          })
        }, _toDisplayString(row[item.field]), 5)]),
        _: 2
      }, 1032, ["field", "title", "width", "align"])) : _createCommentVNode("", true), item.type == 'text_color_row' ? (_openBlock(), _createBlock(_component_vxe_column, {
        key: 2,
        field: item.field,
        title: item.title,
        width: item.width,
        align: item.align
      }, {
        default: _withCtx(({
          row
        }) => [_createElementVNode("span", {
          style: _normalizeStyle({
            'color': row.color_s
          })
        }, _toDisplayString(row[item.field]), 5)]),
        _: 2
      }, 1032, ["field", "title", "width", "align"])) : _createCommentVNode("", true), item.type == 'img_upload' ? (_openBlock(), _createBlock(_component_vxe_column, {
        key: 3,
        field: item.field,
        title: item.title,
        width: item.width,
        align: item.align
      }, {
        default: _withCtx(({
          row
        }) => [_createVNode(_component_el_upload, {
          action: _ctx.data.upLoadUrl,
          "with-credentials": true,
          "on-success": function (res, file, file_list) {
            return _ctx.handleSuccess(res, file, file_list, row);
          },
          "show-file-list": false,
          name: "file",
          limit: 1,
          data: _ctx.data.upLoadQuery,
          accept: ".png, .jpg",
          "on-change": _ctx.handleChange
        }, {
          default: _withCtx(() => [row.image ? (_openBlock(), _createElementBlock("img", {
            key: 0,
            src: row.image,
            class: "avatar"
          }, null, 8, _hoisted_7)) : (_openBlock(), _createBlock(_component_el_icon, {
            key: 1,
            class: "el-icon-plus"
          }))]),
          _: 2
        }, 1032, ["action", "on-success", "data", "on-change"])]),
        _: 2
      }, 1032, ["field", "title", "width", "align"])) : _createCommentVNode("", true), item.type == 'operation' ? (_openBlock(), _createBlock(_component_vxe_column, {
        key: 4,
        field: item.field,
        title: item.title,
        width: item.width,
        align: item.align
      }, {
        default: _withCtx(({
          row,
          $rowIndex
        }) => [row.isDownLoadShow ? (_openBlock(), _createElementBlock("div", _hoisted_8, [_createVNode(_component_vxe_button, {
          type: "text",
          class: "download",
          onClick: $event => _ctx.operationDown(row, item.field)
        }, {
          default: _withCtx(() => _cache[2] || (_cache[2] = [_createTextVNode("下载")])),
          _: 2,
          __: [2]
        }, 1032, ["onClick"]), _createVNode(_component_vxe_button, {
          type: "text",
          class: "delete",
          onClick: $event => _ctx.operationDel($rowIndex)
        }, {
          default: _withCtx(() => _cache[3] || (_cache[3] = [_createTextVNode("删除")])),
          _: 2,
          __: [3]
        }, 1032, ["onClick"])])) : _createCommentVNode("", true), !row.isDownLoadShow ? (_openBlock(), _createElementBlock("div", _hoisted_9, [_createVNode(_component_vxe_button, {
          type: "text",
          class: "delete",
          onClick: $event => _ctx.operationDel($rowIndex)
        }, {
          default: _withCtx(() => _cache[4] || (_cache[4] = [_createTextVNode("删除")])),
          _: 2,
          __: [4]
        }, 1032, ["onClick"])])) : _createCommentVNode("", true)]),
        _: 2
      }, 1032, ["field", "title", "width", "align"])) : _createCommentVNode("", true), item.type == 'downLoadUrl' ? (_openBlock(), _createBlock(_component_vxe_column, {
        key: 5,
        field: item.field,
        title: item.title,
        width: item.width,
        align: item.align
      }, {
        default: _withCtx(({
          row
        }) => [_createElementVNode("div", _hoisted_10, [!row.isShowCopy ? (_openBlock(), _createBlock(_component_vxe_button, {
          key: 0,
          type: "text",
          class: "download",
          onClick: $event => _ctx.operationDown(row, item.field)
        }, {
          default: _withCtx(() => _cache[5] || (_cache[5] = [_createTextVNode("下载")])),
          _: 2,
          __: [5]
        }, 1032, ["onClick"])) : _createCommentVNode("", true)]), _createElementVNode("div", _hoisted_11, [row.isShowCopy ? (_openBlock(), _createBlock(_component_vxe_button, {
          key: 0,
          type: "text",
          class: "download",
          onClick: $event => _ctx.operationCopy(row[item.field])
        }, {
          default: _withCtx(() => _cache[6] || (_cache[6] = [_createTextVNode("复制")])),
          _: 2,
          __: [6]
        }, 1032, ["onClick"])) : _createCommentVNode("", true)])]),
        _: 2
      }, 1032, ["field", "title", "width", "align"])) : _createCommentVNode("", true), item.type == 'editable_ipt' ? (_openBlock(), _createBlock(_component_vxe_column, {
        key: 6,
        field: item.field,
        title: item.title,
        "show-overflow": "",
        width: item.width,
        align: item.align,
        "edit-render": {
          autofocus: '.vxe-input--inner'
        }
      }, {
        edit: _withCtx(scope => [_createVNode(_component_vxe_input, {
          modelValue: scope.row[item.field],
          "onUpdate:modelValue": $event => scope.row[item.field] = $event,
          modelModifiers: {
            trim: true
          },
          disabled: _ctx.data.isDisabled,
          onBlur: $event => _ctx.clearNull(scope.row[item.field], scope.$rowIndex, item.field),
          onChange: $event => _ctx.getDomN.updateStatus(scope)
        }, null, 8, ["modelValue", "onUpdate:modelValue", "disabled", "onBlur", "onChange"])]),
        _: 2
      }, 1032, ["field", "title", "width", "align"])) : _createCommentVNode("", true)]);
    }), 128))]),
    _: 1
  }, 8, ["max-height", "data", "onCheckboxChange", "onCheckboxAll", "show-footer", "merge-footer-items", "loading", "sync-resize"]))], 64);
}